<template>
    <div>
      <el-row type="flex" justify="end">
				<el-button @click="onItemEditClick(null)"  icon="el-icon-plus" type="primary">创建知识
				</el-button>
        <!-- <el-button @click="ExportList()"  icon="el-icon-plus" type="primary">导出
				</el-button> -->
	  </el-row>
    <el-form label-position="left" inline :model="searchForm" label-width="140px" style="margin-top: 30px;">
      <el-row>
      <el-form-item label="创建日期">
        <el-date-picker
          style="width:140px;"
          v-model="searchForm.sDate"
          type="date"
          placeholder="选择日期">
        </el-date-picker>至
        <el-date-picker
          style="width:140px;"
          v-model="searchForm.eDate"
          type="date"
          placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="知识分类">
        <el-select clearable v-model="searchForm.typeArray"  multiple placeholder="选择分类">
          <el-option v-for="item in infotypeList" :key="item.value" :label="item.label"
            :value="item.value"></el-option>
        </el-select>
      </el-form-item>
    </el-row>
    <el-row>
      <el-form-item label="关键字">
        <el-input v-model="searchForm.key" autocomplete="off" placeholder="检索关键字"></el-input>
      </el-form-item>
      <el-button @click="onSearch" type="primary">搜索</el-button>
    </el-row>
    </el-form>

    <el-table 
      :data="infoList.slice((currentPage-1)*PageSize,currentPage*PageSize)" 
      border :header-cell-style="{background:'#eef1f6',color:'#606266'}" height="800"
			style="width: 80%;margin-top: 10px;" ref="Table"      
      >
      <el-table-column prop="typeName" align="center" width="138" label="知识类型"></el-table-column>
      <el-table-column prop="title" align="center" width="100" label="主题">
        <template slot-scope="scope" >
          <div style="color:blue;cursor: pointer;" @click="onView(scope.row)">{{ scope.row.title }}</div>
        </template>
      </el-table-column>
      
      <el-table-column align="center"  label="内容" >
        <template slot-scope="scope" >
             <div>{{scope.row.content.length>100?scope.row.content.substring(0,99)+'...':scope.row.content}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" width="157" label="附件" >
        <template slot-scope="scope" >
          <div v-for="(item,index) in scope.row.sample" :key="index">
            <a :href="item.url" target="_blank">{{ item.name }}</a>
          </div>
<!--              <div :style="{'color':scope.row.statusName=='已结单'?'green':(scope.row.statusName=='已关闭'?'red':'#E58505')}">{{scope.row.statusName}}</div> -->
        </template>
      </el-table-column>

      <el-table-column prop="rowTime" align="center" width="100" label="创建时间" ></el-table-column>
     
      <el-table-column  align="center" width="100" label="操作" >
        <template slot-scope="scope">
          <el-button-group>
            <el-button type="primary" size="small"
            @click.native.prevent="onItemEditClick(scope.row)"
          >编辑</el-button>
          <el-button type="danger" size="small"
            @click.native.prevent="onItemDeleteClick(scope.row)"
          >删除</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>

    <div class="tabListPage">
        <el-pagination @size-change="handleSizeChange" 
                      @current-change="handleCurrentChange" 
                      :current-page="currentPage" 
                      :page-sizes="pageSizes" 
                      :page-size="PageSize" layout="total, sizes, prev, pager, next, jumper" 
                      :total="totalCount">
      </el-pagination>
    </div>
    <el-dialog :title="title" :visible="editDialogVisible" width="70%"
                  :modal-append-to-body='false'
                  :close-on-click-modal='false'
                  @close="editDialogVisible = false" 
                  append-to-body>
					<el-form :model="editForm" inline style="margin-top: 30px;">
            <el-row>
              <el-form-item label="知识类型">
                <el-select clearable multiple v-model="editForm.typeArray" placeholder="选择分类">
                  <el-option v-for="item in infotypeList" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="知识主题">
                <el-input v-model="editForm.title" size="medium" autocomplete="off" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-row>            
            <el-row >
              <el-form-item class="remark" label="内容" >
                <el-col :span="24">
                  <el-input v-model="editForm.content" size="medium" :rows="8" type="textarea"
                  autocomplete="off" placeholder="请输入内容" style="width:80%"
                  ></el-input>
                </el-col>
              </el-form-item>
            </el-row>    
            <el-row>
              <my-upload-file-form-item v-model="editForm.sample" label="附件" :limit="10" />
            </el-row>                                        
				</el-form>

				<div slot="footer" class="dialog-footer">
						<el-button @click="editDialogVisible = false">关闭</el-button>
						<el-button type="primary" @click="onSave">保存</el-button>
				</div>
		</el-dialog>
  
    </div>
  </template>
  
  <script>
  import CommonTable from "@/components/CommonTable";
  import {getLatestMonthDateArrayByDate} from "@/utils/time";
  import { mapGetters } from "vuex";
  import { getToken } from "@/utils/auth";
  import {encrypt} from "@/utils/encrypt";
  import {SaveInfo} from "@/api/workSheet";
  // import ChangeTime from "@/views/WorkSheet/ChangeTime";
  import MyUploadFileFormItem from "@/components/MyUploadFileFormItem";
  import { getSampleArrayFromSever } from "@/views/WorkSheet/xml-manager";
  
  export default {
    name: "Advertiser",
    components: { CommonTable,MyUploadFileFormItem}, 
    props: ['menuModuleId'],
    computed: { ...mapGetters(["infoList","infotypeList"]) },
    data() {
      return {
        title:'新建知识',
        editDialogVisible:false,
        searchForm: {
          key: "",
          // dateArray: getLatestMonthDateArrayByDate({date:new Date(),delayNum:1, formatValue: 'yyyy-MM-dd'}),
          typeArray:[],  
          sDate:getLatestMonthDateArrayByDate({date:new Date(),delayNum:1, formatValue: 'yyyy-MM-dd'})[0],
          eDate:getLatestMonthDateArrayByDate({date:new Date(),delayNum:1, formatValue: 'yyyy-MM-dd'})[1],
        },
        editForm:{
          infoId:0,
          title:'',
          content:'',
          typeArray:[],  
          sample:[],      
        },
        currentItem: {},
        // 默认显示第几页
        currentPage:1,
        // 总条数，根据接口获取数据长度(注意：这里不能为空)
        totalCount:0,
        // 个数选择器（可修改）
        pageSizes:[20,50,100],
        // 默认每页显示的条数（可修改）
        PageSize:50,

      };
    },
    async activated() {

    },
  
    updated(){

    },
    
  
    watch: {
      
    },
 
  
    async created() {
      await this.$store.dispatch("workSheet/infotypeList", );
      // 
      await this.onSearch();
    },
    async mounted() {

    },
    methods: {    
      async onSearch(){
        var sDate = new Date(this.searchForm.sDate).toLocaleDateString();
        var eDate = new Date(this.searchForm.eDate).toLocaleDateString();
        var typeIds = ''
        // console.log('adsd',this.searchForm.typeIds)
        if (this.searchForm.typeArray){
          typeIds = this.searchForm.typeArray.join(',')
        }
        await this.$store.dispatch("workSheet/infoList", {
          sDate:sDate,
          eDate:eDate,
          typeIds,
          key: this.searchForm.key,
        }).then(res=>{
            this.$refs.Table.doLayout();
            this.totalCount=this.infoList.length
            this.currentPage=1            
        });
        
      },

      onView(){

      },
      async onSave(){
        // console.log(this.editForm)
        this.editForm.userId = encrypt(getToken());
        await SaveInfo(this.editForm).then((res)=>{
          if (res.data.data.Result !== 1){
            this.$error.warning(res.data.data.Msg)
          }else{
            this.onSearch()
            this.editDialogVisible = false
          }
        })
      },
      
      onItemEditClick(item){
        if (item == null){
          this.editForm = {
            infoId:0,
            title:'',
            content:'',
            typeArray:[],  
            sample:[],      
          }
        }else{
          var tarray = item.typeIds.split(',')
          var arr2=[]
          tarray.forEach(element => {
            arr2.push(element * 1)
          });
          
          var sample = item.sample;
          // console.log(item,samples)
          this.editForm.infoId = item.infoId
          this.editForm.title = item.title
          this.editForm.content = item.content
          this.editForm.typeArray = arr2
          this.editForm.sample = sample;// getSampleArrayFromSever({sample})
          console.log(this.editForm)
        }
        this.editDialogVisible = true
      },
      onItemDeleteClick(item){

      },
      // 每页显示的条数
      handleSizeChange(val) {
        // 改变每页显示的条数 
        this.PageSize=val
        // 注意：在改变每页显示的条数时，要将页码显示到第一页
        this.currentPage=1
      },
        // 显示第几页
      handleCurrentChange(val) {
          // 改变默认的页数
          this.currentPage=val
      },
  
    },
  };
  </script>
  
  <style scoped>
    
  </style>
  
